import { render, staticRenderFns } from "./BDCReport.vue?vue&type=template&id=02fc3d91&scoped=true"
import script from "./BDCReport.vue?vue&type=script&lang=js"
export * from "./BDCReport.vue?vue&type=script&lang=js"
import style0 from "./BDCReport.vue?vue&type=style&index=0&id=02fc3d91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fc3d91",
  null
  
)

export default component.exports